import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { useFetchData } from "../../../../hooks/useFetchData";
import {
  deleteNotificationActionHandler,
  getAllNotificationsActionHandler,
  triggerNotificationActionHandler,
} from "../../../../store/actions/actionHandlers/adminActionHandler/engagementCenterActionHandler";
import getTenantName from "../../../../utils/getTenantName";
import { engagementCenter } from "../../../../utils/mainTabs/admin/engagementCenter/engagementCenter";
import DataTable from "../../../Common/DataTable/DataTable";
import Modal from "../../../Common/Modal/Modal";
import HistoryIcon from "../../../Common/SvgIcons/AdminIcons/EngagementCenterIcon/HistoryIcon";
import classes from "./EngagementCenterTable.module.scss";
import { FormattedMessage } from "react-intl";
const EngagementCenterTable = () => {
  const pageSize = 8;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const tenantName = getTenantName(dispatch, location);
  const commonState = useSelector((state) => state.commonReducer);
  const { colors } = commonState;
  const { columns } = engagementCenter;
  const notificationHistoryPath =
    engagementCenter.notificationHistoryPath(tenantName);

  const adminStateReducer = useSelector((state) => state.adminReducer);
  const { engagementCenterReducer } = adminStateReducer;
  const { triggerNotificationLoader, deleteNotificationLoader } =
    engagementCenterReducer;

  const [isTriggerModel, setIsTriggerModel] = useState(null);
  const [isDeleteModel, setIsDeleteModel] = useState(null);

  const {
    data,
    setData,
    updatedData,
    setUpdatedData,
    totalRows,
    loading,
    searchQuery,
    handleCurrentPage,
    handleSearchQuery,
  } = useFetchData(getAllNotificationsActionHandler, pageSize);

  const handleNotificationModel = (val, isTrigger) => {
    if (isTrigger) {
      if (val) {
        setIsTriggerModel(val);
      } else {
        setIsTriggerModel(null);
      }
    } else {
      if (val) {
        setIsDeleteModel(val);
      } else {
        setIsDeleteModel(null);
      }
    }
  };
  const handleNotification = () => {
    if (isTriggerModel) {
      dispatch(triggerNotificationActionHandler(isTriggerModel)).then(() => {
        handleNotificationModel(null, true);
      });
    } else {
      dispatch(deleteNotificationActionHandler(isDeleteModel)).then(
        (response) => {
          if (response) {
            const updatedArr = data.filter(
              (dataVal) => dataVal.Id !== isDeleteModel
            );
            setData(updatedArr);
            setUpdatedData(updatedArr);
          }
          handleNotificationModel(null, false);
        }
      );
    }
  };

  return (
    <div className={classes.engagementCenterTable}>
      <div className={classes.engagementCenterTable__header}>
        <div className={classes.engagementCenterTable__header__count}>
          {totalRows || 0} <FormattedMessage id="NOTIFICATION_TEXT" />
        </div>
        <div className={classes.engagementCenterTable__header__actionContainer}>
          {/* <div
            className={
              classes.engagementCenterTable__header__actionContainer__action
            }
            onClick={() => navigate(addNotificationPath)}
          >
            <AddIcon fill={colors.theme} />
            Add New Notification
          </div> */}
          <div
            className={
              classes.engagementCenterTable__header__actionContainer__action
            }
            onClick={() => navigate(notificationHistoryPath)}
          >
            <HistoryIcon fill={colors.theme} />
            <FormattedMessage id="NOTIFICATION_HISTORY" />
          </div>
        </div>
      </div>
      <DataTable
        columns={columns(tenantName, handleNotificationModel, navigate)}
        defaultData={data}
        setDefaultData={setData}
        data={updatedData}
        setData={setUpdatedData}
        totalRows={totalRows}
        loading={loading}
        uniqueFieldName={"Id"}
        fetchMoreData={handleCurrentPage}
        searchable
        searchQuery={searchQuery}
        setSearchQuery={handleSearchQuery}
      />
      <Modal
        isOpen={isTriggerModel || isDeleteModel}
        heading={<FormattedMessage id="USERGROUP_DELETEGRP__HEADERMSG" />}
        toggle={() => handleNotificationModel(null)}
        buttonLabel1={<FormattedMessage id="YES_TEXT" />}
        buttonLabel2={<FormattedMessage id="USERGRP_CANCELBTN_TEXT" />}
        handleSubmit={handleNotification}
        width="46.2"
        height="26.9"
        loading={
          isTriggerModel ? triggerNotificationLoader : deleteNotificationLoader
        }
      >
        <div
          className={classes.engagementCenterTable__triggerNotificationModal}
        >
          <div
            className={
              classes.engagementCenterTable__triggerNotificationModal__text
            }
          >
            <FormattedMessage id="ARE_YOU_SURE_TO_PROCEED" />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default EngagementCenterTable;
